import { render, staticRenderFns } from "./QuotationTab.vue?vue&type=template&id=b1c400cc&scoped=true"
import script from "./QuotationTab.vue?vue&type=script&lang=js"
export * from "./QuotationTab.vue?vue&type=script&lang=js"
import style0 from "./QuotationTab.vue?vue&type=style&index=0&id=b1c400cc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c400cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1c400cc')) {
      api.createRecord('b1c400cc', component.options)
    } else {
      api.reload('b1c400cc', component.options)
    }
    module.hot.accept("./QuotationTab.vue?vue&type=template&id=b1c400cc&scoped=true", function () {
      api.rerender('b1c400cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cardSystem/saleToos/projectDelivery/components/applyForm/QuotationTab.vue"
export default component.exports